/**
 * Centralized configuration constants
 * Single source of truth for API endpoints and core configuration
 * 
 * @module config/constants
 */

import { getEnvString } from '../shared/envHelpers';

/**
 * API endpoint constants
 * These define the backend API URLs used across the application
 */
export const API_ENDPOINTS = {
  /** Direct Function App endpoint */
  PRODUCTION: "https://ll-scraper-prod-app-cndkgwc4auecgvhg.eastus2-01.azurewebsites.net/api",
  /** Staging API endpoint (configurable via environment variable) */
  STAGING: "",
} as const;

const runtimeApiBaseOverride = getEnvString(
  typeof import.meta !== "undefined" ? (import.meta.env?.VITE_EXTENSION_API_BASE as string | false | undefined) : undefined
);
const runtimeLoginBaseOverride = getEnvString(
  typeof import.meta !== "undefined" ? (import.meta.env?.VITE_EXTENSION_LOGIN_BASE as string | false | undefined) : undefined
);

/**
 * Default API base URL
 * Falls back to the production Function App if no environment override is provided
 */
export const DEFAULT_API_BASE = runtimeApiBaseOverride ?? API_ENDPOINTS.PRODUCTION;

/**
 * Default Auth0 audience
 * Must match the Auth0 API identifier that owns the `extension.scrapes.*` scopes
 * (the `llscraperapi` resource server), which is the production API base URL.
 * This is the same value the Function App is configured with via
 * `EXTENSION_AUTH0_AUDIENCE`, so client-issued tokens carry the correct
 * audience and scopes.
 */
export const DEFAULT_AUTH0_AUDIENCE = API_ENDPOINTS.PRODUCTION;

/**
 * Default host used to render the extension login page.
 * Use the Function App directly to ensure the inline login page loads correctly.
 */
export const DEFAULT_EXTENSION_LOGIN_BASE =
  runtimeLoginBaseOverride ?? API_ENDPOINTS.PRODUCTION;
